import { Outlet } from "react-router-dom"
import Header from "./Header"
import LocomotiveProvider from "../LocomotiveProvider"
import Menu from "./Menu"

const Layout = () => {
  return (
    <>
      <Header />
      <Menu />
      <LocomotiveProvider>
        <main>
          <Outlet />
        </main>
      </LocomotiveProvider>
    </>
  )
}

export default Layout
